import React from 'react'
import CuentaSelected from "../../helpers/CuentaSelected";
import AppBreadcrumbs from "../../components/AppBreadcrumbs";
import Api from "../../helpers/Api";
import Env from "../../config/env";
import AppToast from "../../ui/AppToast";
import 'react-confirm-alert/src/react-confirm-alert.css';
import {withRouter} from 'react-router';
import Grid from "@material-ui/core/Grid";
import AppInputText from '../../ui/AppInputText';
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import {Button} from '@material-ui/core';
import Card from "@material-ui/core/Card";
import Icon from "@material-ui/core/Icon";
import ValidateEmail from "../../helpers/ValidateEmail";
import ValidateForm from "../../helpers/ValidateForm";
import {Link} from "react-router-dom";
import Redirect from "../../helpers/Redirect";

const initialForm = {
    email: {
        key: 'email',
        value: '',
        required: false,
        disabled: false,
    },
    email2: {
        key: 'email2',
        value: '',
        required: false,
        disabled: false,
    },
    email3: {
        key: 'email3',
        value: '',
        required: false,
        disabled: false,
    },
    calidad: {
        key: 'calidad',
        value: '',
        required: false,
        disabled: false,
    },
};

class DigitalInvoiceFormModify extends React.Component {

    PqrForm = React.createRef();

    constructor(props) {
        super(props);

        this.state = {
            form: initialForm,
            account: {},
            dataPqrs: [],
            dataCalidad: [],
            dataFactura: [],
            open: false,
            url: ''
        };
    }

    async componentDidMount() {
        this.setState({
            account: CuentaSelected.get()
        });

        this.loadForm();
    }

    getCalidad = async () => {
        const data = await Api.get(`${Env.UrlBackend}/invoice-digital/calidad`);
        if (!data.success) {
            AppToast(data.message, false);
        }
        this.setState({
            dataCalidad: data.data
        });
    }
    
    getInvoiceDigital = async () => {
        const account = CuentaSelected.get();
        const params = {
            cuenta: account.cuentaCodigo,
            tipo: 'NML',
        }

        const data = await Api.post(`${Env.UrlBackend}/invoice-digital/validate`, params);
        if (!data.success) {
            AppToast(data.message, false);
        }
        this.setState({dataFactura: data.data});
    }

    loadForm = async () => {
        await this.getCalidad();
        await this.getInvoiceDigital();

        this.setState({
            form: {
                ...this.state.form,
                email: {
                    ...this.state.form.email,
                    value: (this.state.dataFactura.email1) ? this.state.dataFactura.email1 : '',
                    disabled: true,
                },
                email2: {
                    ...this.state.form.email2,
                    value: (this.state.dataFactura.email2) ? this.state.dataFactura.email2 : '',
                    disabled: false,
                },
                email3: {
                    ...this.state.form.email3,
                    value: (this.state.dataFactura.email3) ? this.state.dataFactura.email3 : '',
                    disabled: false,
                },
                calidad: {
                    ...this.state.form.calidad,
                    value: this.state.dataFactura.calidad_de_id,
                    disabled: false,
                },
            },
        });
    }

    handleChange = async (e) => {
        const {value, name} = e.target;

        this.setState((statePrev) => {
            return {
                form: {
                    ...statePrev.form,
                    [name]: {
                        ...statePrev.form[name],
                        value: value
                    }
                }
            }
        });
    }

    handleSubmit = async (e) => {
        e.preventDefault();
        const account = CuentaSelected.get();

        // Valida los campos obligatorios
        if (!ValidateForm(this.state.form)) {
            return false;
        }

        // Valida formato del email
        if (!ValidateEmail(this.state.form.email.value)) {
            AppToast('El email principal no tiene un formato válido!', false);
            return false;
        }

        // Valida formato del email
        if(this.state.form.email2.value!=='')
        {
            if (!ValidateEmail(this.state.form.email2.value)) {
                AppToast('El email secundario no tiene un formato válido!', false);
                return false;
            }
        }

        // Valida formato del email
        if(this.state.form.email3.value!=='')
        {
            if (!ValidateEmail(this.state.form.email3.value)) {
                AppToast('El email terciario no tiene un formato válido!', false);
                return false;
            }
        }

        if((this.state.form.email.value!=='') && (this.state.form.email2.value!==''))
        {
            if(this.state.form.email.value === this.state.form.email2.value){
                AppToast('Los email deben de ser diferentes!', false);
                return false;
            }
        }

        if((this.state.form.email.value!=='') && (this.state.form.email3.value!==''))
        {
            if(this.state.form.email.value === this.state.form.email3.value){
                AppToast('Los email deben de ser diferentes!', false);
                return false;
            }
        }

        if((this.state.form.email2.value!=='') && (this.state.form.email3.value!==''))
        {
            if(this.state.form.email2.value === this.state.form.email3.value){
                AppToast('Los email deben de ser diferentes!', false);
                return false;
            }
        }

        const paramsEmail = {
            cuenta: account.cuentaCodigo,
            tipo: 'NML',
            email1: this.state.form.email.value,
            email2: this.state.form.email2.value,
            email3: this.state.form.email3.value,
            calidad_de: this.state.form.calidad.value,
            estado: 1,
        }
        const dataEmail = await Api.post(`${Env.UrlBackend}/invoice-digital/save`, paramsEmail);
        if (!dataEmail.success) {
            AppToast('Error al modificar factura digital', false);
            return false;
        }

        AppToast('La factura digital se modificó con éxito', true);

        this.setState({
            url: '/accounts'
        });
    }

    render() {

        return (
            <div className='container-form'>

                <Redirect url={this.state.url}/>

                <AppBreadcrumbs
                    links={[
                        {
                            url: 'accounts',
                            label: 'Cuentas'
                        }
                    ]}
                    actual='Factura Digital'
                />

                <div style={{textAlign: 'center', paddingLeft: '30px', paddingRight: '30px'}}>

                    <h2>Modificar Factura Digital</h2>

                    <form onSubmit={this.handleSubmit}>
                        <Card style={{padding: '20px', width: '80%', margin: 'auto'}}>
                            <div style={{height: '100px'}}>
                                <table className='custom-table'>
                                    <tbody>
                                    <tr>
                                        <th>Nro Cuenta</th>
                                        <td>{this.state.account.cuentaCodigo}</td>
                                        <th>Cliente</th>
                                        <td>{this.state.account.cuentaCliente}</td>
                                    </tr>
                                    <tr>
                                        <th>Dirección</th>
                                        <td>{this.state.account.DIRECCION}</td>
                                        <th>Factura</th>
                                        <td>{this.state.account.cuentaFactura}</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div style={{height: '200px'}}>
                                <Grid container spacing={1}>
                                    <Grid item xs={12} sm={6}>
                                        <AppInputText
                                            id={this.state.form.email.key}
                                            name={this.state.form.email.key}
                                            value={this.state.form.email.value}
                                            disabled={this.state.form.email.disabled}
                                            label='Correo electrónico principal'
                                            onChange={this.handleChange}
                                            required={this.state.form.email.required}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <AppInputText
                                            id={this.state.form.email2.key}
                                            name={this.state.form.email2.key}
                                            value={this.state.form.email2.value}
                                            disabled={this.state.form.email2.disabled}
                                            label='Correo electrónico secundario'
                                            onChange={this.handleChange}
                                            required={this.state.form.email2.required}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <AppInputText
                                            id={this.state.form.email3.key}
                                            name={this.state.form.email3.key}
                                            value={this.state.form.email3.value}
                                            disabled={this.state.form.email3.disabled}
                                            label='Correo electrónico terciario'
                                            onChange={this.handleChange}
                                            required={this.state.form.email3.required}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <FormControl required variant="outlined" style={{width: '100%'}}>
                                            <InputLabel id="demo-simple-select-outlined-label">En calidad de</InputLabel>
                                            <Select
                                                labelId="demo-simple-select-outlined-label"
                                                id={this.state.form.calidad.key}
                                                name={this.state.form.calidad.key}
                                                value={this.state.form.calidad.value}
                                                label="En calidad de"
                                                onChange={this.handleChange}
                                                required={this.state.form.calidad.required}
                                                variant='outlined'
                                            >

                                                {this.state.dataCalidad.map((val, index) => {
                                                    return (
                                                        <MenuItem key={index}
                                                                value={val.id}>{val.descripcion}</MenuItem>
                                                    );
                                                })}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Link to='accounts' variant="body2">
                                            <Button
                                                type='button'
                                                variant="contained"
                                                color="secondary"
                                                size="small"
                                                startIcon={<Icon>close</Icon>}
                                                style={{margin: '10px'}}>
                                                Cancelar
                                            </Button>
                                        </Link>
                                        
                                        <Button
                                            type='submit'
                                            variant="contained"
                                            color="secondary"
                                            size="small"
                                            startIcon={<Icon>check</Icon>}
                                            style={{margin: '10px'}}>
                                            Actualizar
                                        </Button>
                                        
                                    </Grid>
                                </Grid>
                            </div>
                            <div>
                                ¿Deseas dejar de recibir la factura digital marque aquí?
                                <br/>
                                <Link to='delete-digital-invoice' variant="body2">
                                    <Button
                                        type='button'
                                        variant="contained"
                                        color="secondary"
                                        size="small"
                                        startIcon={<Icon>close</Icon>}
                                        style={{margin: '10px'}}>
                                        Desvincular
                                    </Button>
                                </Link>
                            </div>
                        </Card>
                    </form>
                </div>
            </div>

        );
    }
}

export default withRouter(DigitalInvoiceFormModify)
